module.exports = __webpack_public_path__ + "img/sunlogin.a0d3cf74.png";